export const AdvanceVI = {
    "advance":"Advance",
}